import i18next from 'i18next'
import { z } from 'zod'

import { SelectOptionZod, selectOptionZod } from 'components/Select'
import { workspaceBidderPriorities } from 'features/globalSetup/types/bidderPriority'
import { accounts, consentModes } from 'features/globalSetup/types/workspaceBidder'
import { yieldbirdStatuses as statuses } from 'features/globalSetup/types/yieldbirdStatus'
import { BidderSlice } from '../types'

const accountType = z.enum(accounts)
const yieldbirdStatuses = z.enum(statuses)

const commonFields = z.object({
  bidCpmAdjustment: z.number().min(0).max(200).multipleOf(0.01),
  bidderCode: z.string(),
  bidderId: selectOptionZod<BidderSlice>().refine(
    (value: SelectOptionZod<BidderSlice>): boolean => value.value !== '',
    i18next.t('common:form.error.nonEmpty'),
  ),
  bidderSid: z.string().optional(),
  consentMode: z.enum(consentModes),
  priority: z.enum(workspaceBidderPriorities),
})

const ownFields = z.object({
  accountType: accountType.extract(['own']),
})

const yieldbirdFields = z.object({
  accountType: accountType.extract(['yieldbird']),
  status: yieldbirdStatuses,
})

const thirdPartyProviderFields = z.object({
  accountType: accountType.extract(['thirdPartyProvider']),
  supplyChain: z.string().min(1),
})

const accountTypeFields = z.discriminatedUnion('accountType', [
  ownFields,
  yieldbirdFields,
  thirdPartyProviderFields,
])

export const commonSchema = commonFields
  .and(accountTypeFields)
  .superRefine(({ accountType, bidderCode }, ctx) => {
    if (
      (accountType === 'own' || accountType === 'thirdPartyProvider') &&
      bidderCode.length === 0
    ) {
      ctx.addIssue({
        code: 'custom',
        message: i18next.t('common:form.error.isRequired'),
        path: ['bidderCode'],
      })
    }
  })

export type CommonSchema = z.infer<typeof commonSchema>
